import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  userLogin,
  fetchCustomerForgotPasswordSuccess,
  clearLoginMessage,
} from "redux/actions/user";
import { useForm } from "react-hook-form";
import "./login-page.scss";
import { getLocalStorageValue } from "config/helper";

const LoginPage = () => {
  const recaptchaRef = React.createRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clientId = getLocalStorageValue("RSAclient-id");

  const [recaptchaValue, setRecaptchaValue] = useState("");
  const [captchaError, setCaptchaError] = useState("");

  const {loginError, loginLoading} = useSelector(({ user }) => user);

  const headerSectionData = useSelector(
    ({ common }) => common.commonDetailsData.header_section
  );

  const {
    is_numeric_password,
    your_recaptcha_site_key,
    complex_password_max_length,
    complex_password_min_length,
    numeric_password_length,
  } = headerSectionData;

  const { register, handleSubmit, errors } = useForm();

  useEffect(() => {
    dispatch(fetchCustomerForgotPasswordSuccess(""));
  }, [dispatch]);

  const handleLoginSuccess = () => {
    const redirectUrl = sessionStorage.getItem("_aog_login_redirect_url")
    if (redirectUrl) { 
      sessionStorage.removeItem("_aog_login_redirect_url");
      // Add a small delay to ensure the auth state is updated
      setTimeout(() => {
        navigate(redirectUrl);
      }, 10);
    } else {
      navigate("/");
    }
  };

  const submitUserLogin = (data) => {
    const { email, password } = data;
    const body = {
      RSAClientId: clientId,
      email_id: email,
      password: password,
    };
    if (recaptchaValue) {
      setCaptchaError("");
      dispatch(userLogin(body, handleLoginSuccess));
    } else {
      setCaptchaError("The captcha field is required");
    }
  };

  const onChangeReCaptcha = (value) => {
    setRecaptchaValue(value);
    setCaptchaError("");
  };

  const breadcrumbList = [{ lable: "Sign In", link: "" }];

  useEffect(() => {
    return () => {
      dispatch(clearLoginMessage());
    };
  }, [dispatch]);

  return (
    <>
      <BreadcrumbDetailed breadcrumbList={breadcrumbList} title={`Sign In`} />

      <div className="login-page-wrapper">
        <div className="container">
          <div className="auth-grid-alignment">
            <div className="auth-grid">
              <div className="auth-grid-items">
                <div className="logo-center-wrapper">
                  <img
                    src={headerSectionData.rsa_client_logo}
                    alt={headerSectionData.image_alt_text}
                  />
                </div>
                <h1>
                  Great to
                  <span>see you back</span>
                </h1>
                 <p>
                  Don't have an account?{" "}
                  <span>
                    <Link to="/signup" className="create-btn">Create here</Link>
                  </span>
                </p>
              </div>
              <div className="auth-grid-items">
                <h2>Sign In</h2>
                <form name="login" onSubmit={handleSubmit(submitUserLogin)}>
                  <div className="form-control">
                    <label>Email Address *</label>
                    <input
                      name="email"
                      id="email"
                      ref={register({
                        required: true,
                        pattern:
                          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      })}
                    />
                    {errors.email && errors.email.type === "required" && (
                      <span>Please enter email.</span>
                    )}
                    {errors.email && errors.email.type === "pattern" && (
                      <span>
                        The email address entered is invalid, please check the
                        formatting (e.g. email@domain.com)
                      </span>
                    )}
                  </div>
                  {is_numeric_password === "1" ? (
                    <div className="form-control">
                      <label>Pin *</label>
                      <input
                        name="password"
                        id="password"
                        type="password"
                        maxLength={
                          is_numeric_password === "1"
                            ? numeric_password_length
                            : complex_password_max_length
                        }
                        minLength={
                          is_numeric_password === "1"
                            ? numeric_password_length
                            : complex_password_min_length
                        }
                        ref={register({
                          required: true,
                          minLength: 4,
                          pattern: /^[0-9]+$/, // eslint-disable-line
                        })}
                      />

                      {errors.password &&
                        errors.password.type === "required" && (
                          <span>Please enter Pin.</span>
                        )}
                      {errors.password &&
                        errors.password.type === "pattern" && (
                          <span>Pin must contain only number.</span>
                        )}

                      <Link to="/forgot-password">Forgot Pin ?</Link>
                    </div>
                  ) : (
                    <div className="form-control">
                      <label> Password *</label>
                      <input
                        name="password"
                        id="password"
                        type="password"
                        maxLength={
                          is_numeric_password === "1"
                            ? numeric_password_length
                            : complex_password_max_length
                        }
                        minLength={
                          is_numeric_password === "1"
                            ? numeric_password_length
                            : 4
                        }
                        ref={register({
                          required: true,
                          minLength: 4,
                          // maxLength: +complex_password_max_length,
                        })}
                      />
                      {errors.password &&
                        errors.password.type === "required" && (
                          <span>Please enter Password.</span>
                        )}
                      <Link to="/forgot-password">Forgot Password?</Link>
                    </div>
                  )}
                  {loginError ? (
                    <span className="login-error">{loginError}</span>
                  ) : (
                    ""
                  )}
                  <div className="re-captcha">
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={your_recaptcha_site_key}
                      onChange={onChangeReCaptcha}
                    />
                    <span style={{ color: "red" }}>{captchaError}</span>
                  </div>
                  <div className="sign-in-button">
                    <button type="submit" disabled={loginLoading}>
                      {loginLoading ? "Signing In..." : "Sign In"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
